import { adminConstants } from "../_constants"
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

const adminList = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/list"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                // dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.ADMIN_GET_LIST_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_GET_LIST_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_GET_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at adminList", error);
    }
}

const adminTypeAdmin = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/adminTypeList"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                // dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.ADMIN_TYPE_GET_LIST_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_TYPE_GET_LIST_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_TYPE_GET_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at adminTypeAdmin", error);
    }
}


const adminListForCust = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/adminListForCust"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                // dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.ADMIN_CUSTOMER_LIST_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_CUSTOMER_LIST_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_CUSTOMER_LIST_FAILURE, error }; }

    } catch (error) {
        console.log("Error at adminListForCust", error);
    }
}

const saveAdmin = (data, handleClose, filterData = {}) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/addNewRole"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(adminList(filterData));
                dispatch(success(admin));
                dispatch(alertActions.success("New Role Create Successfully"));
                handleClose()
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.ADD_NEW_ADMIN_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADD_NEW_ADMIN_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADD_NEW_ADMIN_FAILURE, error }; }

    } catch (error) {
        console.log("Error at saveAdmin", error);
    }
}

const updateAdmin = (data, handleClose, filterData = {}) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/update"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(adminList(filterData));
                dispatch(success(admin));
                dispatch(alertActions.success("Status Update Successfully"));
                handleClose();
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.UPDATE_ADMIN_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.UPDATE_ADMIN_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.UPDATE_ADMIN_FAILURE, error }; }

    } catch (error) {
        console.log("Error at updateAdmin", error);
    }
}

const blockUnblock = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/blockUnblock"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                dispatch(adminList())
                dispatch(alertActions.success("Action Successfully"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        }
        function request(admin) { return { type: adminConstants.ADMIN_BLOCK_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_BLOCK_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_BLOCK_FAILURE, error }; }
    } catch (error) {
        console.log("Error at blockUnblock", error);
    }
}

const softDelete = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/delete"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                dispatch(adminList())
                dispatch(alertActions.success("Deleted Successfully"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        }
        function request(admin) { return { type: adminConstants.ADMIN_DELETE_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_DELETE_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_DELETE_FAILURE, error }; }
    } catch (error) {
        console.log("Error at blockUnblock", error);
    }
}

const getAssignedCustomerIds = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/admin/getAssignedCustomerIds"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((admin) => {
                dispatch(success(admin));
                // dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message));
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(admin) { return { type: adminConstants.ADMIN_GET_ASSIGNED_IDS_REQUEST, admin }; }
        function success(admin) { return { type: adminConstants.ADMIN_GET_ASSIGNED_IDS_SUCCESS, admin }; }
        function failure(error) { return { type: adminConstants.ADMIN_GET_ASSIGNED_IDS_FAILURE, error }; }

    } catch (error) {
        console.log("Error at getAssignedCustomerIds", error);
    }
}


export const adminActions = {
    adminList,
    saveAdmin,
    updateAdmin,
    blockUnblock,
    softDelete,
    getAssignedCustomerIds,
    adminTypeAdmin,
    adminListForCust
}